import { NotificationModel } from 'models/NotificationModel';
import { createReducer } from 'store/createReducer';
import { NOTIFICATION_SET, NOTIFICATION_CLOSE, NotificationSetAction } from './actions';

const reducer = {
  [NOTIFICATION_CLOSE]: (state: NotificationModel) => {
    return { ...state, show: false };
  },
  [NOTIFICATION_SET]: (_: NotificationModel, { type, ...action }: NotificationSetAction) => ({
    ...action,
    show: true
  })
};

export const initialState: NotificationModel = {
  show: false,
  text: '',
  title: ''
};

export default createReducer(initialState, reducer);
